import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import './CertificatePage.css';

const AdminCertificatePage = () => {
  const navigate = useNavigate();
  const certificateRef = useRef(null);
  const [studentName, setStudentName] = useState('');
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (!certificateRef.current) return;
    if (!studentName.trim()) {
        alert('Please enter a student name.');
        return;
    }
    setIsDownloading(true);
    try {
      // Clone the certificate element to ensure high-quality desktop layout capture
      const original = certificateRef.current;
      const clone = original.cloneNode(true);
      
      // Apply capture-mode class
      clone.classList.add('certificate-capture-mode');
      document.body.appendChild(clone);

      const canvas = await html2canvas(clone, {
        scale: 2, // Higher scale for better quality
        useCORS: true,
        logging: false,
        backgroundColor: '#fffaf0', // Match CSS background
        windowWidth: 800,
        windowHeight: 600
      });

      document.body.removeChild(clone);

      const imgData = canvas.toDataURL('image/png');
      // Create PDF with landscape orientation matching canvas dimensions
      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
        format: [canvas.width, canvas.height]
      });

      pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
      pdf.save(`${studentName.replace(/[^a-zA-Z0-9]/g, '_')}_Certificate.pdf`);
    } catch (error) {
      console.error('Error generating certificate:', error);
      alert('Failed to generate certificate. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  const completionDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="certificate-page-container" style={{ minHeight: 'calc(100vh - 64px)' }}>
      <div className="certificate-controls" style={{ flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
        <h2 style={{ color: 'white', marginBottom: '1rem' }}>Manual Certificate Generation</h2>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <input 
                type="text" 
                value={studentName}
                onChange={(e) => setStudentName(e.target.value)}
                placeholder="Enter Student Name"
                style={{ 
                    padding: '0.75rem', 
                    borderRadius: '0.5rem', 
                    border: 'none', 
                    width: '300px',
                    fontSize: '1rem'
                }}
            />
            <button onClick={handleDownload} disabled={isDownloading} className="btn-primary">
            {isDownloading ? 'Generating PDF...' : 'Download Certificate'}
            </button>
            <button onClick={() => navigate('/admin/dashboard')} className="btn-secondary">
            Back to Dashboard
            </button>
        </div>
      </div>

      <div className="certificate-preview-area">
        <div className="certificate-paper" ref={certificateRef}>
          <div className="certificate-border">
            <div className="certificate-content">
              <div className="certificate-header">
                <img src="/sruti-vaibhavam.png" alt="Sruti Vaibhavam" className="event-logo" crossOrigin="anonymous" />
                <h1 className="certificate-title">Certificate of Completion</h1>
                <p className="certificate-subtitle">This is to certify that</p>
              </div>

              <div className="certificate-name-section">
                <h2 className="student-name">{studentName || 'Student Name'}</h2>
                <div className="underline"></div>
              </div>

              <div className="certificate-body">
                <h2 className="exhibition-title">SRI SATHYA SAI SRUTI VAIBHAVAM</h2>
                <h3 className="exhibition-theme">JOURNEY FORWARD TO SAI ALONG WITH VEDIC PATH</h3>
              </div>

              <div className="certificate-footer">
                <div className="footer-item">
                  <span className="date-text">{completionDate}</span>
                  <div className="footer-line"></div>
                  <span className="footer-label">Date</span>
                </div>
                
                <div className="footer-org">
                   <p className="org-text">by Sri Sathya Sai Seva Organisations India</p>
                   <img src="/logo.png" alt="SSSSO India" className="org-logo" crossOrigin="anonymous" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminCertificatePage;